
import React, { PureComponent } from "react"
import throttle from "lodash/throttle";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
class ArticleSocialTitle extends PureComponent {
  constructor(props) {
    super(props);
    this.setChangeValue = throttle(this._setChangeValue, 100);
    this.textArea = React.createRef();
    this.state = { length: 0, title: props.title || "" };
  }

  componentDidMount() {
    const { defaultValue } = this.props;
    let length = 0;
    if (defaultValue) {
      length = defaultValue.length;
    }
    this.setState({ length });
  }
  _setChangeValue = (e) => {
    this.props.setArticleSocialTitle(e.target.value, e.type);
  }
  onChange = (e) => {
    e.persist();
    this.setState({ length: e.target.value.length, title: e.target.value });
    this.setChangeValue(e);
  }
  render() {
    const { title } = this.state;

    return (
      <div className="labelPadding" style={{ display: "flex", alignItems: "flex-end" }}>
        <TextField
          id="standard-name"
          label="Facebook Headline"
          value={title}
          onChange={this.onChange}
          onBlur={this.onChange}
          InputProps={{
            disableUnderline: true,
            endAdornment: <InputAdornment position="start" style={{whiteSpace:"nowrap"}}>{`${title && title.length || 0}/100`}</InputAdornment>,
            style: {
              border: 'none',
              lineHeight: "1.5",
              fontSize: "16px",
              fontWeight: "normal",
              border: '1px solid #ced3dc',
              padding: '5px 10px',
            },
          }}
          inputProps={{ maxLength: 300 }}
          multiline={true}
          fullWidth
          margin="normal"
        />
      </div>
    )
  }
}
export default ArticleSocialTitle;
